import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-sidebar-my-links',
  templateUrl: './sidebar-my-links.component.html',
  styleUrls: ['./sidebar-my-links.component.scss'],
  animations: [
    trigger('openClose', [
      state('opened', style({
        height: '*',
        opacity: 1
      })),
      state('closed', style({
        height: '0',
        opacity: 0
      })),
      transition('opened => closed', [
        animate('.2s')
      ]),
      transition('closed => opened', [
        animate('0.2s')
      ])
    ])
  ]
})
export class SidebarMyLinksComponent {
  opened: boolean = false;
  @Input() generalSettingsData:any;
}
